const cl10LongSerialRegExp = new RegExp(/(001|510)-[\d]{4}-[\d]{4}-[A-Za-z]{2}-[\d]{2}/);
const cl55LongSerialRegExp = new RegExp(/(002|511)-[\d]{4}-[\d]{4}-[A-Za-z]{2}-[\d]{2}/);
const cl10SerialRegExp = new RegExp(/(001|510)-[\d]{4}-[\d]{4}-[A-Za-z]{2}$/);
const cl55SerialRegExp = new RegExp(/(002|511)-[\d]{4}-[\d]{4}-[A-Za-z]{2}$/);
export const isConsoleSerialNumber = ({ t }) => (value) => {
    const snRegex = new RegExp(/(^[a-zA-Z0-9]{9}$)|(^[a-zA-Z0-9]{11}$)|(^[a-zA-Z0-9-]{17}$)/);
    return value && !snRegex.test(value) ? t('common:validators:format:console_serial_number') : undefined;
};
export const isDeviceSerialNumber = ({ t }) => (value) => {
    const snRegex = new RegExp(/^[a-zA-Z0-9-]{8,}$/);
    return (value && value.trim().length < 8) || !snRegex.test(value)
        ? t('common:validators:format:device_serial_number')
        : undefined;
};
export const isCL10SerialNumber = ({ t }) => (value) => {
    return value && !(cl10SerialRegExp.test(value) || cl10LongSerialRegExp.test(value))
        ? t('common:validators:format:cl10_serial_number')
        : undefined;
};
export const isCL55SerialNumber = ({ t }) => (value) => {
    return value && !(cl55SerialRegExp.test(value) || cl55LongSerialRegExp.test(value))
        ? t('common:validators:format:cl55_serial_number')
        : undefined;
};
export const MODEL_INPUT_NAME = 'replacementModel';
export const notTheSameDevice = ({ t, params: input }) => (value, allValues) => {
    const { serialNumber, model, hasDuplicated } = input;
    return hasDuplicated
        ? value === serialNumber && allValues.replacementModel === model
            ? t(`common:validators:format:cant_use_same_device`)
            : undefined
        : value === serialNumber
            ? t(`common:validators:format:cant_use_same_device`)
            : undefined;
};
//# sourceMappingURL=validation.serialNumbers.js.map